import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell.tsx';
import { RequireAdmin, RequireAuth } from './components/Guards.tsx';
import { EcrituresPerdues } from './components/EcrituresPerdues.tsx';
import { UpdateBanner } from './components/UpdateBanner.tsx';
import { AuthProvider } from './lib/auth.tsx';
import { NotificationsProvider } from './lib/notifications.tsx';
import { ReseauProvider } from './lib/reseau.tsx';
import { SettingsProvider } from './lib/settings.tsx';
import { UpdatesProvider } from './lib/updates.tsx';
import { ChangePassword } from './pages/ChangePassword.tsx';
import { Home } from './pages/Home.tsx';
import { EtapeParcours } from './pages/training/EtapeParcours.tsx';
import { Passages } from './pages/training/Passages.tsx';
import { Licence } from './pages/Licence.tsx';
import { Login } from './pages/Login.tsx';
import { Preferences } from './pages/Preferences.tsx';
import { Statistics } from './pages/Statistics.tsx';
import { MyEquipment } from './pages/equipment/MyEquipment.tsx';
import { SessionHistory } from './pages/training/SessionHistory.tsx';
import { SessionSummary } from './pages/training/SessionSummary.tsx';
import { CourseEditor } from './pages/courses/CourseEditor.tsx';
import { CourseImport } from './pages/courses/CourseImport.tsx';
import { RoundPlay } from './pages/rounds/RoundPlay.tsx';
import { RoundStart } from './pages/rounds/RoundStart.tsx';
import { RoundJoin } from './pages/rounds/RoundJoin.tsx';
import { RoundHistory } from './pages/rounds/RoundHistory.tsx';
import { RoundCard } from './pages/rounds/RoundCard.tsx';
import { CourseCard } from './pages/courses/CourseCard.tsx';
import { CoursesList } from './pages/courses/CoursesList.tsx';
import { ExerciseEditor } from './pages/training/ExerciseEditor.tsx';
import { RunScreen } from './pages/training/RunScreen.tsx';
import { RunSummary } from './pages/training/RunSummary.tsx';
import { WorkoutList } from './pages/training/WorkoutList.tsx';
import { Training } from './pages/training/Training.tsx';
import { TrainingHome } from './pages/training/TrainingHome.tsx';
import { WorkoutComposer } from './pages/training/WorkoutComposer.tsx';
import { AdminBackups } from './pages/admin/AdminBackups.tsx';
import { AdminLayout } from './pages/admin/AdminLayout.tsx';
import { AdminOverview } from './pages/admin/AdminOverview.tsx';
import { AdminSettings } from './pages/admin/AdminSettings.tsx';
import { AdminUsers } from './pages/admin/AdminUsers.tsx';
import { FriendInvite } from './pages/putting/FriendInvite.tsx';
import { Friends } from './pages/putting/Friends.tsx';
import { FriendProfile } from './pages/putting/FriendProfile.tsx';
import { NewPuttingGame } from './pages/putting/NewPuttingGame.tsx';
import { PuttingGame } from './pages/putting/PuttingGame.tsx';
import { PuttingHome } from './pages/putting/PuttingHome.tsx';

export default function App() {
    return (
        <BrowserRouter>
            {/* Au-dessus de l'authentification : une mise à jour se propose
                aussi à quelqu'un resté sur l'écran de connexion — et la bande
                est rendue ici, hors des routes, pour la même raison. */}
            <UpdatesProvider>
            <UpdateBanner />
            <AuthProvider>
                {/* La file d'attente démarre AVANT les écrans : elle porte au
                    serveur ce qui restait de la dernière sortie, sans attendre
                    qu'un écran la réveille. */}
                <ReseauProvider>
                {/* Sous la bande de mise a jour, au-dessus des ecrans : un
                    incident de saisie doit se lire quel que soit l'ecran ou
                    l'on se trouve quand la file rattrape son retard. */}
                <EcrituresPerdues />
                <SettingsProvider>
                    <NotificationsProvider>
                    <Routes>
                        <Route path="/connexion" element={<Login />} />

                        <Route
                            element={<RequireAuth><AppShell /></RequireAuth>}
                        >
                            <Route path="/" element={<Home />} />
                            <Route path="/mot-de-passe" element={<ChangePassword />} />
                            {/* Pas d'entrée dans le tiroir : on y accède par le
                                bloc utilisateur, en bas du menu. Une ligne de
                                plus aurait encombré un écran qu'on ouvre d'une
                                main en marchant. */}
                            <Route path="/licence" element={<Licence />} />
                            <Route path="/preferences" element={<Preferences />} />
                            <Route path="/statistiques" element={<Statistics />} />

                            {/* Les parcours : les golfs où l'on va jouer. Une
                                branche à part de /entrainement, dont ils ne
                                partagent ni le modèle ni les écrans — on n'y
                                compte pas des balles centrées mais des coups
                                par trou. */}
                            <Route path="/parcours" element={<CoursesList />} />
                            <Route path="/parcours/nouveau" element={<CourseEditor />} />
                            {/* L'import est une operation d'exploitation :
                                le serveur le refuse aux autres, et la route
                                le dit aussi, pour ne pas offrir un ecran qui
                                ne peut aboutir. */}
                            <Route path="/parcours/importer"
                                element={<RequireAdmin><CourseImport /></RequireAdmin>} />
                            <Route path="/parcours/:id/carnet" element={<CourseCard />} />
                            {/* Le tour en cours : une seule adresse, parce
                                qu'on ne joue qu'un parcours a la fois. */}
                            <Route path="/parcours/jouer" element={<RoundPlay />} />
                            <Route path="/parcours/historique" element={<RoundHistory />} />
                            <Route path="/parcours/tour/:id" element={<RoundCard />} />
                            <Route path="/parcours/:id/jouer" element={<RoundStart />} />
                            <Route path="/parcours/rejoindre/:id" element={<RoundJoin />} />
                            <Route path="/parcours/:id" element={<CourseEditor />} />

                            <Route path="/materiel" element={<MyEquipment />} />
                            {/* Ancienne adresse, conservée le temps que les
                                signets et l'écran d'accueil suivent. */}
                            <Route path="/sac" element={<Navigate to="/materiel" replace />} />
                            {/* Deux niveaux, et la distinction porte le reste de
                                l'arborescence : une SÉANCE est un plan écrit à
                                l'avance, un EXERCICE en est une brique. Le menu
                                s'ouvre sur les séances ; le catalogue
                                d'exercices est une marche en dessous. */}
                            <Route path="/entrainement" element={<TrainingHome />} />
                            <Route path="/entrainement/seances" element={<WorkoutList />} />
                            <Route path="/entrainement/passages/:workoutId"
                                element={<Passages />} />
                            <Route path="/entrainement/seance-en-cours/parcours/:position"
                                element={<EtapeParcours />} />
                            <Route path="/entrainement/seance-en-cours" element={<RunScreen />} />
                            <Route path="/entrainement/bilan/:id" element={<RunSummary />} />
                            <Route path="/entrainement/exercices" element={<Training />} />
                            <Route path="/entrainement/exercice/:id" element={<ExerciseEditor />} />
                            <Route path="/entrainement/seance/:id" element={<WorkoutComposer />} />
                            <Route path="/entrainement/historique" element={<SessionHistory />} />
                            {/* Après les segments fixes : sinon « historique »
                                ou « exercices » seraient pris pour des
                                identifiants de séance. Les éditeurs sont au
                                SINGULIER — /entrainement/exercice/:id — pour ne
                                pas se disputer le préfixe avec la liste. */}
                            <Route path="/entrainement/:id" element={<SessionSummary />} />

                            {/* Putting : le seul volet collaboratif, et le seul
                                qui ignore la notion de sac — on ne compose rien
                                pour aller taper des putts, on prend son putter.
                                D'où une branche à lui plutôt qu'un mode de
                                /entrainement, dont il ne partage ni le modèle
                                ni les écrans.

                                Les routes fixes AVANT /:id, sinon « amis » et
                                « nouvelle » seraient pris pour des identifiants
                                de partie. */}
                            <Route path="/putting" element={<PuttingHome />} />
                            <Route path="/putting/nouvelle" element={<NewPuttingGame />} />
                            <Route path="/amis/invitation/:token" element={<FriendInvite />} />
                            <Route path="/putting/:id" element={<PuttingGame />} />

                            {/* Les partenaires ont leur adresse à eux : ils ne
                                servent qu'au putting aujourd'hui, mais se
                                gèrent en dehors d'une partie, et l'entrée du
                                tiroir doit pointer sur quelque chose de stable.
                                L'ancienne adresse est conservée le temps que
                                les liens déjà partagés cessent de circuler. */}
                            <Route path="/amis" element={<Friends />} />
                            <Route path="/amis/:id" element={<FriendProfile />} />
                            <Route path="/putting/amis" element={<Navigate to="/amis" replace />} />

                            {/* Back-office : même application, aucune adresse
                                séparée. Une seule entrée « Admin » dans le
                                tiroir mène ici ; les sous-sections sont des
                                onglets de cette page, ce qui laisse de la
                                place pour en ajouter sans encombrer le menu.

                                La garde est posée une fois, sur la coquille.
                                Elle masque l'écran ; c'est le serveur qui
                                refuse les données. */}
                            <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                                <Route index element={<AdminOverview />} />
                                <Route path="utilisateurs" element={<AdminUsers />} />
                                <Route path="sauvegardes" element={<AdminBackups />} />
                                <Route path="parametres" element={<AdminSettings />} />
                            </Route>
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    </NotificationsProvider>
                </SettingsProvider>
                </ReseauProvider>
            </AuthProvider>
            </UpdatesProvider>
        </BrowserRouter>
    );
}
